import { HowItWorks } from "@/components/landing/HowItWorks";

export default function HowItWorksPage() {
  return (
    <div data-testid="how-it-works-page">
      <HowItWorks />
    </div>
  );
}
